import { render, staticRenderFns } from "./Demos.vue?vue&type=template&id=3ff5e7a3&scoped=true&"
import script from "./Demos.vue?vue&type=script&lang=js&"
export * from "./Demos.vue?vue&type=script&lang=js&"
import style0 from "./Demos.vue?vue&type=style&index=0&id=3ff5e7a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5e7a3",
  null
  
)

export default component.exports